import React from 'react';

export default function Tank40Icon({
  width = 64,
  height = 31,
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 54.058" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Port">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="49.5493" y1="4.4741" x2="66.7793" y2="4.4741">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M49.549,5.949h17.23V3h-17.23V5.949" />
	<path fill="#FFFFFF" d="M49.775,1.804h0.676v1.464h-0.676V1.804z" />
	<path fill="#FFFFFF" d="M49.775,1.804h0.676V0.452h-0.676V1.804z" />
	<path fill="#8D8D8D" d="M46.959,3.718h1.014V0h-1.014V3.718z" />
	<path fill="#8D8D8D" d="M50,3.718h0.788V0H50V3.718z" />
	<path fill="#8D8D8D" d="M53.153,3.718h0.675V0h-0.675V3.718z" />
	<path fill="#8D8D8D" d="M56.194,3.718h0.675V0h-0.675V3.718z" />
	<path fill="#8D8D8D" d="M59.234,3.718h0.788V0h-0.788V3.718z" />
	<path fill="#8D8D8D" d="M62.049,3.718h1.014V0h-1.014V3.718z" />
	<path fill="#8D8D8D" d="M65.203,3.718h0.9V0h-0.9V3.718z" />
	<path fill="#8D8D8D" d="M68.243,3.718h0.901V0h-0.901V3.718z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="46.5088" y1="2.5356" x2="69.9326" y2="2.5356">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M46.509,1.804h23.424v1.464H46.509V1.804" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="46.5088" y1="1.1279" x2="69.9326" y2="1.1279">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M46.509,1.804h23.424V0.452H46.509V1.804" />
	<rect x="46.509" y="1.528" fill="#676767" width="23.424" height="0.542" />
</g>
<g id="Group_TankBody">
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="62.0938" y1="47.187" x2="62.0938" y2="5.4077">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M102.763,5.407H11.688l0.625,41.78h90.45c0,0,9.737-0.991,9.737-21.059   C112.5,6.029,102.763,5.407,102.763,5.407z" />
	
		<radialGradient id={`${id}_5_`} cx="56.1396" cy="-20.4883" r="16.0904" gradientTransform="matrix(1 0 0 1.3 -47.1162 52.9321)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.18" style={{stopColor: "#D3D3D3"}} />
		<stop offset="0.56" style={{stopColor: "#979797"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_5_)`} d="M0,27.029c0,18.672,12.313,20.158,12.313,20.158s5.734-3.813,5.734-20.158   c0-19.755-6.359-21.622-6.359-21.622S0,6.546,0,27.029z" />
</g>
<g id="Group_Tank_Support">
	<path fill="#7E7E7E" d="M28.829,47.187h-7.432l14.415,6.869v-3.604L28.829,47.187z" />
	<path fill="#7E7E7E" d="M89.752,47.187h-7.319l14.414,6.869v-3.604L89.752,47.187z" />
	<path fill="#B1B1B1" d="M25.225,47.187h-7.32l14.415,6.869v-3.604L25.225,47.187z" />
	<path fill="#B1B1B1" d="M86.262,47.187h-7.658l14.752,6.869v-3.604L86.262,47.187z" />
	<path fill="#CBCBCB" d="M32.32,54.056h1.014v-3.266H32.32V54.056z" />
	<path fill="#CBCBCB" d="M93.355,54.056h0.676v-3.266h-0.676V54.056z" />
	<path fill="#CBCBCB" d="M35.811,54.056h0.788v-3.266h-0.788V54.056z" />
	<path fill="#CBCBCB" d="M96.847,54.056h0.676v-3.266h-0.676V54.056z" />
	<path fill="#B1B1B1" d="M32.095,29.957c0,0,0.322,3.739-1.464,11.374c-1.152,4.925-5.18,5.856-5.18,5.856l7.32,3.266V29.957H32.095   z" />
	<path fill="#B1B1B1" d="M93.018,29.861c0,0,0.436,3.739-1.351,11.374c-1.151,4.925-5.181,5.856-5.181,5.856l7.32,3.266V29.861   H93.018z" />
	<path fill="#B1B1B1" d="M32.095,29.957h2.815L30.405,5.407h-4.729c0,0,4.948,2.328,5.968,12.725   C31.933,21.076,32.095,29.957,32.095,29.957z" />
	<path fill="#B1B1B1" d="M93.018,29.957h2.928L91.217,5.407h-4.505l1.126,0.45l1.238,1.239l1.127,1.802l1.014,2.59l0.676,3.153   l0.675,3.491l0.226,4.054l0.225,4.279V29.957z" />
	<path fill="#B1B1B1" d="M93.132,29.957h2.814L91.442,5.407h-4.73c0,0,4.948,2.328,5.969,12.725   C92.97,21.076,93.132,29.957,93.132,29.957z" />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="31.1372" y1="50.7905" x2="31.1372" y2="5.1826">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M36.148,17.682c-0.203-5.69-0.899-9.279-4.504-12.5h-5.968c0,0,5.767,2.565,6.657,12.5   c0.494,5.514,0.438,12.274,0.438,12.274v20.834h3.829c0,0,0-15.625,0-20.834C36.599,24.323,36.267,20.996,36.148,17.682z" />
	<linearGradient id={`${id}_7_`} gradientUnits="userSpaceOnUse" x1="91.9482" y1="50.7905" x2="91.9482" y2="5.1826">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_7_)`} d="M96.959,17.682c-0.203-5.69-0.898-9.279-4.504-12.5h-5.969c0,0,5.767,2.565,6.656,12.5   c0.494,5.514,0.438,12.274,0.438,12.274v20.834h3.829c0,0,0-15.625,0-20.834C97.41,24.323,97.077,20.996,96.959,17.682z" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="54.058" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
